import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export const PrivateRoutes = () => {
  const { user, validateToken } = useAuth();
  const location = useLocation();

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  try {
    validateToken()
  } catch (e) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />; 
};